// Button.js
import React from "react";
import { useNavigate } from "react-router-dom";

const Button = ({ children, to, scrollTo }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    scrollTo
      ? window.scrollBy({ top: scrollTo, behavior: "smooth" })
      : navigate(to);
  };

  return (
    <button
      className="justify-center w-full p-3 mb-4 text-white capitalize duration-300 
      transition-all bg-blue-500 shadow cursor-pointer focus:outline-none 
      sm:mb-0 sm:w-auto sm:mr-4 md:pl-8 md:pr-6 xl:pl-12 xl:pr-10 
      hover:translate-y-[-4px] hover:translate-x-[-4px] hover:shadow-[4px_4px_4px_grey]
      active:translate-x-0 active:translate-y-0 active:shadow-none"
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

export default Button;
